"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useBackWarning = function (message) {
    (0, react_1.useEffect)(function () {
        var onPopState = function () {
            var shouldLeave = window.confirm(message);
            if (shouldLeave) {
                window.removeEventListener("popstate", onPopState);
                window.history.back();
                return;
            }
            window.history.pushState(null, "", window.location.href);
        };
        window.history.pushState(null, "", window.location.href);
        window.addEventListener("popstate", onPopState);
        return function () {
            window.removeEventListener("popstate", onPopState);
        };
    }, [message]);
};
exports.default = useBackWarning;
